/**
 * Shop by Occasion — pin the section and convert vertical scroll
 * into a horizontal rail, matching the Figma Make sticky track.
 */
(function () {
  const DESKTOP = '(min-width: 750px)';

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function setup(root) {
    const rail = root.querySelector('[data-kk-occasion-rail]');
    const sticky = root.querySelector('.kk-occasion__sticky');
    if (!rail || !sticky) return;

    let travel = 0;
    let paneHeight = 0;
    let pinTop = 0;
    let ticking = false;

    function canPin() {
      return window.matchMedia(DESKTOP).matches && !prefersReducedMotion();
    }

    function measure() {
      const pin = canPin();
      root.classList.toggle('is-pinned', pin);
      if (!pin) {
        root.style.height = '';
        rail.style.setProperty('--occasion-x', '0px');
        return;
      }
      rail.style.setProperty('--occasion-x', '0px');
      travel = Math.max(0, Math.round(rail.scrollWidth - root.clientWidth));
      // The pane is only as tall as its content and is pinned in the middle
      // of the screen, so no empty viewport-height band sits around it.
      root.style.removeProperty('--occasion-pane');
      paneHeight = Math.min(sticky.offsetHeight, window.innerHeight);
      pinTop = Math.round((window.innerHeight - paneHeight) / 2);
      root.style.setProperty('--occasion-pane', paneHeight + 'px');
      root.style.setProperty('--occasion-top', pinTop + 'px');
      root.style.height = travel > 0 ? paneHeight + travel + 'px' : '';
      update();
    }

    function update() {
      if (!root.classList.contains('is-pinned') || travel <= 0) return;
      const distance = root.offsetHeight - paneHeight;
      if (distance <= 0) return;
      const progress = Math.max(0, Math.min(1, (pinTop - root.getBoundingClientRect().top) / distance));
      rail.style.setProperty('--occasion-x', `${-progress * travel}px`);
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        update();
        ticking = false;
      });
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', measure, { passive: true });
    rail.querySelectorAll('img').forEach(function (img) {
      if (!img.complete) img.addEventListener('load', measure, { once: true });
    });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(measure);
    window.addEventListener('load', measure);
    window.requestAnimationFrame(measure);
  }

  function boot() {
    document.querySelectorAll('[data-kk-occasion]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    const root = event.target.querySelector('[data-kk-occasion]');
    if (root) setup(root);
  });
})();
